export const API_BASE_URL = process.env.REACT_APP_API || "http://localhost:5000";
export const PUBLIC_URL = process.env.PUBLIC_URL || "";
